<script>
import Colorable from 'vuetify/es5/mixins/colorable'
import VIcon from 'vuetify/es5/components/VIcon/VIcon'

//  Usato soprattutto nelle prenotazioni per mostrare degli avvisi testuali
export default {
    name: 'AlertChip',
    mixins: [Colorable],
    props: {
        dense: Boolean,
        block: Boolean,
        singleLine: Boolean,
        gradient: Boolean,
        closeable: Boolean
    },
    methods: {
        genContent (h) {
            return h('span', {
                staticClass: 'alert-chip__container',
                class: {
                    'alert-chip__container-with-close': this.closeable
                }
            }, this.$slots.default)
        },
        genClose (h) {
            let _this = this
            return h('div', {
                staticClass: 'alert-chip__close',
                on: {
                    click (e) {
                        e.stopPropagation()
                        _this.$emit('click:close')
                    }
                }
            }, [h(VIcon, '$vuetify.icons.delete')])
        }
    },
    render (h) {
        return h('div', this.setBackgroundColor((this.gradient ? 'gradient-' : '') + this.color, {
            staticClass: 'alert-chip',
            class: {
                'alert-chip--dense': this.dense,
                'alert-chip--single-line': this.singleLine,
                'v-card--hover': !!this.$listeners.click
            },
            on: this.$listeners,
            directives: this.$listeners.click ? [{ name: 'ripple' }] : []
        }), [this.genContent(h), this.closeable && this.genClose(h)])
    }
}
</script>

<style scoped lang="scss">
  .alert-chip {
    padding: 5px 7px;
    border-radius: 4px !important;
    color: white;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;

    &--dense {
      padding: 2px 7px;
      font-size: 12px;
      font-weight: 400;
    }

    &--single-line &__container {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__container {

      &-with-close {
        display: flex;
        flex: 1;
      }
    }

    &__close {
      display: flex;
      flex: 0;
      color: inherit;
      font-size: 20px;

      & > .v-icon:hover {
        opacity: 1;
      }

      & > .v-icon {
        color: inherit !important;
        font-size: 20px;
        cursor: pointer;
        opacity: 0.5;
      }
    }
  }
</style>
